module.exports = __webpack_public_path__ + "img/logo.5499f6c6.svg";